<template>
  <v-dialog v-model="dialog" max-width="1200px" persistent :color="corEspecialidade">
    <v-card class="mx-auto">
      <v-card-title class="headline white--text modal-header-especialidade">
        Agendamentos do Paciente
        <v-spacer></v-spacer>
        <v-btn icon dark @click="fecharModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <soi-dashboard-agendamentos
          :paciente-id="pacienteId"
          :componente="true"
          ref="dashboardAgendamentos"
        ></soi-dashboard-agendamentos>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'soi-modal-dashboard-agendamento',

  props: {
    pacienteId: {
      type: [String, Number],
      required: true,
    },
    componente: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialog: false,
    };
  },

  computed: {
    corEspecialidade() {
      const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--especialidade-primary').trim();
      return primaryColor || '#2e4b9d';
    },
  },

  methods: {
    abrirModal() {
      this.dialog = true;
      this.$nextTick(() => {
        (this.$refs.dashboardAgendamentos as any).listarAgendamentos?.();
      });
    },

    fecharModal() {
      this.dialog = false;
    },
  },

  created() {
    this.$parent.$on('abrirModalDashboard', this.abrirModal);
  },
  beforeDestroy() {
    this.$parent.$off('abrirModalDashboard', this.abrirModal);
  },
});
</script>

<style scoped>
.modal-header-especialidade {
  background: var(--especialidade-gradient, linear-gradient(135deg, #2e4b9d 0%, #4a6fa5 100%)) !important;
}
</style>
